import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Head from 'next/head';
import Link from 'next/link';
import Button from '@components/Shared/Buttons/Button';
import ScrollUpButtonContainer from '@components/Shared/ScrollUpButton/ScrollUpButtonContainer';

import { padItems } from '@utils/formatters';
import { getBranding, getLatestResources } from '@services/newsroomService';
import Hero from '@components/Newsroom/Hero/Hero';
import BrandingCard from '@components/Newsroom/BrandingCard/BrandingCard';
import ResourceCard from '@components/Newsroom/ResourceCard/ResourceCard';
import ClaytonLogo from '@components/Shared/ClaytonLogo/ClaytonLogo';
import PressKitsStyles from './PressKits.styled';
import { prefixRoute } from '@utils/newsroomUtils';

const PressKits = ({ ssrBranding, ssrLatestResources }) => {
  const [branding, setBranding] = useState(ssrBranding);
  const [latestResources, setLatestResources] = useState(ssrLatestResources);

  if (!branding) {
    getBranding()
      .then((result) => {
        setBranding(result.slice(0, 2));
      })
      .catch();
  }

  if (!latestResources) {
    getLatestResources()
      .then((result) => {
        setLatestResources(result);
      })
      .catch();
  }

  return (
    <div className="constrained-width-newsroom">
      <PressKitsStyles>
        <Head>
          <title>Press Kits | Clayton Newsroom</title>
          <meta
            name="description"
            content="Learn about recent Clayton announcements and news when you download media press kits."
          />
          <meta property="og:image" content={ClaytonLogo} />
        </Head>
        <Hero>Press Kits</Hero>
        <ScrollUpButtonContainer />

        <div className="branding-section">
          <h3>Branding</h3>
          <div className="branding-cards">
            {branding &&
              branding.map((branding, index) => {
                return (
                  <BrandingCard key={`branding-${index}`} branding={branding} />
                );
              })}
            {padItems(branding, 2)}
          </div>
        </div>
        {/* <div className="branding-section">
          <h3>Photography</h3>
          <p>To request photography, email us at <a href="mailto:media@claytonhomes.com">media@claytonhomes.com</a> and we can help you choose images for your story.</p>
        </div> */}
        <div className="branding-section">
          <h3>Resources</h3>
          <div className="branding-cards resources-cards">
            {latestResources &&
              latestResources.slice(0, 8).map((resource, index) => {
                return (
                  <ResourceCard key={`resource-${index}`} resource={resource} />
                );
              })}
            {padItems(latestResources.slice(0, 8), 4)}
          </div>
        </div>
        {latestResources.length > 8 ? (
          <div className="branding-actions">
            <Button
              className="gtm-view-all"
              navigateUrl={prefixRoute('/resources')}
              nextJSUrl={prefixRoute('/resources')}
              linkComponent={Link}
            >
              VIEW ALL RESOURCES
            </Button>
          </div>
        ) : null}
      </PressKitsStyles>
    </div>
  );
};

PressKits.propTypes = {
  ssrBranding: PropTypes.any,
  ssrLatestResources: PropTypes.any,
};

//eslint-disable-next-line no-unused-vars
export async function getServerSideProps() {
  let branding = null,
    latestResources = null;

  await getBranding()
    .then((result) => {
      branding = result.slice(0, 2);
    })
    .catch((error) => {
      console.error(`Error retrieving getBranding: ${error}`);
    });

  await getLatestResources()
    .then((result) => {
      latestResources = result;
    })
    .catch((error) => {
      console.error(`Error retrieving getLatestResources: ${error}`);
    });

  return {
    props: {
      ssrBranding: branding,
      ssrLatestResources: latestResources,
    },
  };
}

export default PressKits;
